import { z } from "zod";

export const MachineTypeSchema = z.enum(["PRINTER", "CUTTER", "PLOTTER"]);
export type MachineType = z.infer<typeof MachineTypeSchema>;

export const ManufacturerSchema = z.enum([
  "KONICA_MINOLTA",
  "FUJI_XEROX",
  "FUJI_FILM",
  "RICOH",
  "CANON",
  "HP",
  "EPSON",
  "DAEHO",
  "OKI",
  "SINDOH",
  "OCE",
  "DUPLO",
]);
export type Manufacturer = z.infer<typeof ManufacturerSchema>;

export const MachineProtocolSchema = z.enum([
  "SNMP",
  "FIERY",
  "DAEHO",
  // 공유 폴더 파일 수집 — 네트워크 인터페이스가 없는 장비(예: Duplo DC-618)용.
  // 장비 PC 가 라우터 공유 폴더에 로그를 저장하면 라우터가 읽어간다.
  "SHARED_FOLDER",
]);
export type MachineProtocol = z.infer<typeof MachineProtocolSchema>;

export const MachineProductEntitySchema = z.object({
  id: z.number(),
  machineType: MachineTypeSchema,
  manufacturer: ManufacturerSchema,
  machineName: z.string().nullable().optional(),
  machineDescription: z.string().nullable().optional(),
  protocol: MachineProtocolSchema,
  machineStatusCommand: z.string().nullable().optional(),
  machineRuntimeCommand: z.string().nullable().optional(),
  suppliesNameCommand: z.string().nullable().optional(),
  suppliesTypeCommand: z.string().nullable().optional(),
  suppliesMaxLevelCommand: z.string().nullable().optional(),
  suppliesCurrentLevelCommand: z.string().nullable().optional(),
  trayNameCommand: z.string().nullable().optional(),
  paperNameCommand: z.string().nullable().optional(),
  paperWidthCommand: z.string().nullable().optional(),
  paperHeightCommand: z.string().nullable().optional(),
  trayMaxCapacityCommand: z.string().nullable().optional(),
  trayCurrentCapacityCommand: z.string().nullable().optional(),
  jobNameCommand: z.string().nullable().optional(),
  jobStartTimeCommand: z.string().nullable().optional(),
  jobEndTimeCommand: z.string().nullable().optional(),
  jobStatusCommand: z.string().nullable().optional(),
  machineTotalWorkloadCommand: z.string().nullable().optional(),
  alertSeverityCommand: z.string().nullable().optional(),
  alertGroupCommand: z.string().nullable().optional(),
  alertCodeCommand: z.string().nullable().optional(),
  alertDescriptionCommand: z.string().nullable().optional(),
  alertTimeCommand: z.string().nullable().optional(),
  errorStateCommand: z.string().nullable().optional(),
});

export type MachineProductEntity = z.infer<typeof MachineProductEntitySchema>;

export const CreateMachineProductRequestSchema = z.object({
  machineType: MachineTypeSchema,
  manufacturer: ManufacturerSchema,
  machineName: z.string().nullable().optional(),
  machineDescription: z.string().nullable().optional(),
  protocol: MachineProtocolSchema,
  machineStatusCommand: z.string().nullable().optional(),
  machineRuntimeCommand: z.string().nullable().optional(),
  suppliesNameCommand: z.string().nullable().optional(),
  suppliesTypeCommand: z.string().nullable().optional(),
  suppliesMaxLevelCommand: z.string().nullable().optional(),
  suppliesCurrentLevelCommand: z.string().nullable().optional(),
  trayNameCommand: z.string().nullable().optional(),
  paperNameCommand: z.string().nullable().optional(),
  paperWidthCommand: z.string().nullable().optional(),
  paperHeightCommand: z.string().nullable().optional(),
  trayMaxCapacityCommand: z.string().nullable().optional(),
  trayCurrentCapacityCommand: z.string().nullable().optional(),
  jobNameCommand: z.string().nullable().optional(),
  jobStartTimeCommand: z.string().nullable().optional(),
  jobEndTimeCommand: z.string().nullable().optional(),
  jobStatusCommand: z.string().nullable().optional(),
  machineTotalWorkloadCommand: z.string().nullable().optional(),
  alertSeverityCommand: z.string().nullable().optional(),
  alertGroupCommand: z.string().nullable().optional(),
  alertCodeCommand: z.string().nullable().optional(),
  alertDescriptionCommand: z.string().nullable().optional(),
  alertTimeCommand: z.string().nullable().optional(),
  errorStateCommand: z.string().nullable().optional(),
});

export type CreateMachineProductRequest = z.infer<
  typeof CreateMachineProductRequestSchema
>;

// ---

export const MachineProductSearchParamsSchema = z.object({
  machineName: z.string().nullable().optional(),
  machineDescription: z.string().nullable().optional(),
});

export type MachineProductSearchParams = z.infer<
  typeof MachineProductSearchParamsSchema
>;

export const UpdateMachineProductRequestSchema =
  CreateMachineProductRequestSchema;

export type UpdateMachineProductRequest = z.infer<
  typeof UpdateMachineProductRequestSchema
>;

// 머신 제품 응답 스키마
